import { tr } from './tr';
import { en } from './en';

export const sozlukler = { tr, en } as const;
export type Dil = keyof typeof sozlukler;
export type SozlukAnahtari = keyof typeof tr;

const DIL_ANAHTARI = 'hotelcms.dil';

export function aktifDil(): Dil {
  const kayitli = localStorage.getItem(DIL_ANAHTARI) as Dil | null;
  if (kayitli && kayitli in sozlukler) return kayitli;
  return navigator.language.startsWith('en') ? 'en' : 'tr';
}

export function dilAyarla(dil: Dil) {
  localStorage.setItem(DIL_ANAHTARI, dil);
  location.reload();
}

/** Turkce varsayilan; eksik anahtar Turkce metne duser. */
export function ceviri(dil: Dil = aktifDil()) {
  const sozluk = sozlukler[dil] as Record<string, string>;
  return (anahtar: SozlukAnahtari): string => sozluk[anahtar] ?? tr[anahtar];
}
